import { forwardRef, Fragment, useContext, useState } from "react";
import { UserDetailPanel } from "./UserDetailPanel";
import { UserModuleContext } from "../../context/UserModuleContext";
import { ModuleContext } from "../../context/ModuleContext";
import { AppBar, Dialog, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { OptionsMenu } from "./OptionsMenu";
import { ModuleContainer } from "../ModuleContainer";
import { RestrictedAccountAlert, VipAlert } from "./RestrictedAccountAlert";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const UserContainer = () => {
    const { userModule, setUserModule } = useContext(UserModuleContext);

    const [module, setModule] = useState({
        isVisible: false,
        element: null,
        validated: false,
        validationError: null,
        userId: null,
        isLog: false,
    });

    const handleClose = () => {
        setUserModule((prev) => ({ ...prev, isOpen: false, userId: null, wsuId: null, isLoaded: false }));
        setModule((prev) => ({ ...prev, isVisible: false, element: null, validated: false, validationError: null, userId: null, isLog: false }));
    };

    return (
        <Fragment>
            <Dialog fullScreen open={userModule.isOpen} TransitionComponent={Transition}>
                <ModuleContext.Provider value={{ module, setModule }}>
                    <ModuleContainer />

                    <AppBar sx={{ position: "relative", backgroundColor: "#A60F2D", color: "white" }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                {userModule.userId + " - " + userModule.wsuId}
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    {userModule.isLoaded && (
                        <RestrictedAccountAlert isRestricted={userModule.userData["Restricted From Modification In Tech Tools"]} />
                    )}

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: 24, padding: 16, flex: 1, minHeight: 0, overflowY: "auto" }}>
                        {/* Person + AD info tiles, wrapping left to right within the space left by the options menu */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <UserDetailPanel identifier={userModule.userId} />
                        </div>

                        {/* Options menu */}
                        {userModule.isLoaded && (
                            <div style={{ flexShrink: 0 }}>
                                <OptionsMenu
                                    identifier={userModule.userData["Network ID"]}
                                    username={userModule.userData["Network ID"]}
                                    isRestricted={userModule.userData["Restricted From Modification In Tech Tools"]}
                                />
                            </div>
                        )}
                    </div>
                </ModuleContext.Provider>
            </Dialog>
        </Fragment>
    );
};